import { Enum, EnumType } from 'ts-jenum';

@Enum<UserStatusEnum>('value')
export class UserStatusEnum extends EnumType<UserStatusEnum>() {
   static readonly UNKNOWN = new UserStatusEnum(0);
   static readonly AVAILABLE = new UserStatusEnum(-1);
   static readonly BUSY = new UserStatusEnum(-2);
   static readonly ACW = new UserStatusEnum(-3);
   static readonly LOGGED_OFF = new UserStatusEnum(-4);
   static readonly DND = new UserStatusEnum(-5);
   static readonly CALL_WAITING = new UserStatusEnum(-6);
   static readonly OFFLINE = new UserStatusEnum(-100);

   private constructor(public readonly value: number) {
      super();
   }
}
